import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import type { FeatureLike } from "ol/Feature";

export type YellowFootProperties = {
    color?: string;
    symbol?: string;
    label?: string;
    rotation?: number;
    "priority-rank"?: number;
    "image-src"?: string;
    "image-yaw"?: number;
    "image-pitch"?: number;
};

export type DangerZoneProperties = {
    color?: string;
    label?: string;
    "image-src"?: string;
    "image-yaw"?: number;
    "image-pitch"?: number;
};

export type YellowFootFeature = Feature<Point, YellowFootProperties>;
export type DangerZoneFeature = Feature<Point, DangerZoneProperties>;

export function isFeatureWithProperties(feature: unknown): feature is Feature {
    return feature instanceof Feature && feature.getProperties() !== undefined;
}

export function getPanoramaProperties(feature: Feature): {
    imageSrc?: string;
    imageYaw?: number;
    imagePitch?: number;
    label?: string;
} {
    const properties = feature.getProperties() as Record<string, unknown>;

    return {
        imageSrc: typeof properties["image-src"] === "string" ? properties["image-src"] : undefined,
        imageYaw: typeof properties["image-yaw"] === "number" ? properties["image-yaw"] : undefined,
        imagePitch: typeof properties["image-pitch"] === "number" ? properties["image-pitch"] : undefined,
        label: typeof properties.label === "string" ? properties.label : undefined,
    };
}

export function hasPanorama(feature: FeatureLike): boolean {
    if (!isFeatureWithProperties(feature)) {
        return false;
    }

    const clusteredFeatures = feature.get("features");
    if (Array.isArray(clusteredFeatures)) {
        return clusteredFeatures.some((clusteredFeature: unknown) =>
            hasPanorama(clusteredFeature as FeatureLike));
    }

    return Boolean(getPanoramaProperties(feature).imageSrc);
}
